import { pathOr } from "ramda";
import WithRender from "../../templates/base/uploadActions.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getShowPreviewInUpload",
      "getBaseUrl",
      "getDisableDeleteUploadAfterConnect",
      "getUploadForProductPart"
    ]),
    showDeleteButton: function () {
      return !this.getDisableDeleteUploadAfterConnect;
    }
  },
  methods: {
    ...mapActions([
      "uploadOnPreview",
      "uploadOnDownload",
      "uploadOnViewReport",
      "uploadOnRearrange",
      "uploadOnDelete"
    ]),
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    },
    wasPreflightExecutedSuccessfully: function () {
      return pathOr(
        false,
        ["wasPreflightExecutedSuccessfully"],
        this.uploadedFileData
      );
    },
    getUploadedFileUrl: function (type) {
      const apiResponseFiles = pathOr("", ["files"], this.uploadedFileData);
      if (apiResponseFiles) {
        return apiResponseFiles.find(urlObj => urlObj.type === type)?.path;
      }
      return "";
    },
    openUrlToDownload: function (url) {
      if (url) {
        window.open(url, "_blank");
      }
    }
  },
  props: ["areLinksExpired", "uploadedFileData", "propsData", "useClassName"]
});
